var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 157,
    viewBox: "0 0 375 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9057 69.0451V69.2137C84.9057 70.7399 86.1413 71.9755 87.6675 71.9755C96.1333 71.9755 102.999 78.8375 102.999 87.3071C102.999 95.7768 96.133 102.643 87.6636 102.639H87.6633H24.3317C15.8659 102.639 9 95.7767 9 87.3071C9 78.8416 15.866 71.9755 24.34 71.9755C25.8664 71.9755 27.097 70.7438 27.1018 69.2192V69.2176V69.2137C27.1018 58.2557 35.9987 49.3587 46.9568 49.3587C54.3106 49.3587 60.7347 53.3625 64.1687 59.312C64.5507 59.9755 65.1906 60.4479 65.9346 60.6196C66.6782 60.7912 67.4602 60.6483 68.0947 60.2237L68.0948 60.2237C69.8122 59.0738 71.876 58.4019 74.0978 58.4019C80.009 58.4019 84.8169 63.1555 84.9057 69.0451Z",
    fill: "url(#paint0_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.7 86.9125L156.71 87.2967L157.083 87.3862C163.962 89.0332 169 95.1349 169 102.6C169 111.22 161.928 118.2 153.3 118.2H92.4C82.7798 118.2 75 110.327 75 100.7C75 91.0774 82.775 83.298 92.4026 83.1995C93.4681 83.1997 94.4374 83.2966 95.5104 83.4916L96.2343 83.6231L96.0901 82.9017C96.0019 82.4601 95.9999 81.9141 95.9999 81.2998C95.9999 74.676 101.276 69.3998 107.9 69.3998C111.741 69.3998 115.195 71.2251 117.302 74.0022L117.688 74.5122L118.09 74.0133C122.101 69.0236 128.161 65.8 135.1 65.8C146.827 65.8 156.407 75.1824 156.7 86.9125Z",
    fill: "url(#paint1_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.906 66.0451V66.2137C203.906 67.7399 205.141 68.9755 206.667 68.9755C215.133 68.9755 221.999 75.8375 221.999 84.3071C221.999 92.7768 215.133 99.6426 206.664 99.6388H206.663H143.332C134.866 99.6388 128 92.7767 128 84.3071C128 75.8416 134.866 68.9755 143.34 68.9755C144.866 68.9755 146.097 67.7438 146.102 66.2192V66.2176V66.2137C146.102 55.2557 154.999 46.3587 165.957 46.3587C173.311 46.3587 179.735 50.3625 183.169 56.312C183.551 56.9755 184.191 57.4479 184.935 57.6196C185.678 57.7912 186.46 57.6483 187.095 57.2237L187.095 57.2237C188.812 56.0738 190.876 55.4019 193.098 55.4019C199.009 55.4019 203.817 60.1555 203.906 66.0451Z",
    fill: "url(#paint2_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.7 101.912L251.71 102.297L252.083 102.386C258.962 104.033 264 110.135 264 117.6C264 126.22 256.928 133.2 248.3 133.2H187.4C177.78 133.2 170 125.327 170 115.7C170 106.077 177.775 98.298 187.403 98.1995C188.468 98.1997 189.437 98.2966 190.51 98.4916L191.234 98.6231L191.09 97.9017C191.002 97.4601 191 96.9141 191 96.2998C191 89.676 196.276 84.3998 202.9 84.3998C206.741 84.3998 210.195 86.2251 212.302 89.0022L212.688 89.5122L213.09 89.0133C217.101 84.0236 223.161 80.8 230.1 80.8C241.827 80.8 251.407 90.1824 251.7 101.912Z",
    fill: "url(#paint3_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.906 43.0451V43.2137C278.906 44.7399 280.141 45.9755 281.667 45.9755C290.133 45.9755 296.999 52.8375 296.999 61.3071C296.999 69.7768 290.133 76.6426 281.664 76.6388H281.663H218.332C209.866 76.6388 203 69.7767 203 61.3071C203 52.8416 209.866 45.9755 218.34 45.9755C219.866 45.9755 221.097 44.7438 221.102 43.2192V43.2176V43.2137C221.102 32.2557 229.999 23.3587 240.957 23.3587C248.311 23.3587 254.735 27.3625 258.169 33.312C258.551 33.9755 259.191 34.4479 259.935 34.6196C260.678 34.7912 261.46 34.6483 262.095 34.2237L262.095 34.2237C263.812 33.0738 265.876 32.4019 268.098 32.4019C274.009 32.4019 278.817 37.1555 278.906 43.0451Z",
    fill: "url(#paint4_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.906 82.0451V82.2137C312.906 83.7399 314.141 84.9755 315.667 84.9755C324.133 84.9755 330.999 91.8375 330.999 100.307C330.999 108.777 324.133 115.643 315.664 115.639H315.663H252.332C243.866 115.639 237 108.777 237 100.307C237 91.8416 243.866 84.9755 252.34 84.9755C253.866 84.9755 255.097 83.7438 255.102 82.2192V82.2176V82.2137C255.102 71.2557 263.999 62.3587 274.957 62.3587C282.311 62.3587 288.735 66.3625 292.169 72.312C292.551 72.9755 293.191 73.4479 293.935 73.6196C294.678 73.7912 295.46 73.6483 296.095 73.2237L296.095 73.2237C297.812 72.0738 299.876 71.4019 302.098 71.4019C308.009 71.4019 312.817 76.1555 312.906 82.0451Z",
    fill: "url(#paint5_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M370.7 95.9125L370.71 96.2967L371.083 96.3862C377.962 98.0332 383 104.135 383 111.6C383 120.22 375.928 127.2 367.3 127.2H306.4C296.78 127.2 289 119.327 289 109.7C289 100.077 296.775 92.298 306.403 92.1995C307.468 92.1997 308.437 92.2966 309.51 92.4916L310.234 92.6231L310.09 91.9017C310.002 91.4601 310 90.9141 310 90.2998C310 83.676 315.276 78.3998 321.9 78.3998C325.741 78.3998 329.195 80.2251 331.302 83.0022L331.688 83.5122L332.09 83.0133C336.101 78.0236 342.161 74.8 349.1 74.8C360.827 74.8 370.407 84.1824 370.7 95.9125Z",
    fill: "url(#paint6_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M398.7 52.9125L398.71 53.2967L399.083 53.3862C405.962 55.0332 411 61.1349 411 68.6C411 77.22 403.928 84.1995 395.3 84.1995H334.4C324.78 84.1995 317 76.327 317 66.6995C317 57.0774 324.775 49.298 334.403 49.1995C335.468 49.1997 336.437 49.2966 337.51 49.4916L338.234 49.6231L338.09 48.9017C338.002 48.4601 338 47.9141 338 47.2998C338 40.676 343.276 35.3998 349.9 35.3998C353.741 35.3998 357.195 37.2251 359.302 40.0022L359.688 40.5122L360.09 40.0133C364.101 35.0236 370.161 31.8 377.1 31.8C388.827 31.8 398.407 41.1824 398.7 52.9125Z",
    fill: "url(#paint7_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7001 101.912L59.7097 102.297L60.0835 102.386C66.9621 104.033 71.9999 110.135 71.9999 117.6C71.9999 126.22 64.9279 133.2 56.3 133.2H-4.6C-14.2202 133.2 -22 125.327 -22 115.7C-22 106.077 -14.225 98.298 -4.59741 98.1995C-3.53186 98.1997 -2.56262 98.2966 -1.48956 98.4916L-0.765665 98.6231L-0.909864 97.9017C-0.998125 97.4601 -1.0001 96.9141 -1.0001 96.2998C-1.0001 89.676 4.27596 84.3998 10.8999 84.3998C14.7413 84.3998 18.195 86.2251 20.3015 89.0022L20.6884 89.5122L21.0896 89.0133C25.101 84.0236 31.1612 80.8 38.0999 80.8C49.8273 80.8 59.4067 90.1824 59.7001 101.912Z",
    fill: "url(#paint8_linear_7209_30383)",
    stroke: "#E1DEF8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7209_30383",
    x1: 2.32506,
    y1: 119.423,
    x2: 109.957,
    y2: 53.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7209_30383",
    x1: 68.325,
    y1: 134.719,
    x2: 174.999,
    y2: 68.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7209_30383",
    x1: 121.325,
    y1: 116.423,
    x2: 228.957,
    y2: 50.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7209_30383",
    x1: 163.325,
    y1: 149.719,
    x2: 269.999,
    y2: 83.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7209_30383",
    x1: 196.325,
    y1: 93.4228,
    x2: 303.957,
    y2: 27.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7209_30383",
    x1: 230.325,
    y1: 132.423,
    x2: 337.957,
    y2: 66.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7209_30383",
    x1: 282.325,
    y1: 143.719,
    x2: 388.999,
    y2: 77.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7209_30383",
    x1: 310.325,
    y1: 100.719,
    x2: 416.999,
    y2: 34.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7209_30383",
    x1: -28.675,
    y1: 149.719,
    x2: 77.9986,
    y2: 83.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsImg);
export default __webpack_public_path__ + "static/media/clouds-img.c38fdd3340b120d86d995733a4ce0501.svg";
export { ForwardRef as ReactComponent };